import { render, staticRenderFns } from "./AppInfoPage.vue?vue&type=template&id=63ee7f68&scoped=true"
import script from "./AppInfoPage.vue?vue&type=script&lang=js"
export * from "./AppInfoPage.vue?vue&type=script&lang=js"
import style0 from "./AppInfoPage.vue?vue&type=style&index=0&id=63ee7f68&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ee7f68",
  null
  
)

export default component.exports